var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("validation-observer", {
            ref: "AddTemplateForm",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var invalid = ref.invalid
                  return [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.formSubmitted($event)
                          },
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Template Name",
                                      "label-for": "mc-Template-name",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Name",
                                        vid: "Name",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "mc-Template-name",
                                                    placeholder:
                                                      "Template Name",
                                                    disabled: "",
                                                  },
                                                  model: {
                                                    value: _vm.template.name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.template,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "template.name",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Platform Type",
                                      "label-for": "platform-type",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        name: "Platform Type",
                                        vid: "Platform Type",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("v-select", {
                                                  staticClass:
                                                    "item-selector-title",
                                                  attrs: {
                                                    options: _vm.platformTypes,
                                                    label: "text",
                                                    multiple: "",
                                                    clearable: false,
                                                    placeholder:
                                                      "Select Platform Type",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    disabled: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.template.platformType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.template,
                                                        "platformType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "template.platformType",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Subject",
                                      "label-for": "textarea-default",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "Subject",
                                        vid: "Subject",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    id: "textarea-default",
                                                    type: "text",
                                                    placeholder: "Subject",
                                                    disabled: "",
                                                  },
                                                  model: {
                                                    value: _vm.template.subject,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.template,
                                                        "subject",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "template.subject",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c("span", [_vm._v("Template Content")]),
                                _c("quill-editor", {
                                  ref: "quillEditor",
                                  attrs: {
                                    options: _vm.editorOption,
                                    disabled: true,
                                  },
                                  model: {
                                    value: _vm.template.body,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.template, "body", $$v)
                                    },
                                    expression: "template.body",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _vm.previewMedia.length
                                  ? _c(
                                      "div",
                                      { staticClass: "preview-container" },
                                      [
                                        _c("h5", [_vm._v("Media Files:")]),
                                        _c(
                                          "b-row",
                                          _vm._l(
                                            _vm.previewMedia,
                                            function (media, index) {
                                              return _c(
                                                "b-col",
                                                {
                                                  key: index,
                                                  staticClass: "mb-2",
                                                  attrs: { cols: "4" },
                                                },
                                                [
                                                  _c(
                                                    "b-card",
                                                    {
                                                      staticClass:
                                                        "preview-card",
                                                    },
                                                    [
                                                      media.type === "photos"
                                                        ? _c("b-img", {
                                                            staticClass:
                                                              "preview-media",
                                                            attrs: {
                                                              src: media.src,
                                                              alt: "Preview Image",
                                                            },
                                                          })
                                                        : media.type ===
                                                          "videos"
                                                        ? _c(
                                                            "video",
                                                            {
                                                              staticClass:
                                                                "preview-media",
                                                              attrs: {
                                                                controls: "",
                                                              },
                                                            },
                                                            [
                                                              _c("source", {
                                                                attrs: {
                                                                  src: media.src,
                                                                  type: "video/webm",
                                                                },
                                                              }),
                                                              _vm._v(
                                                                " Your browser does not support the video tag. "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "mt-1 w-100",
                                                          attrs: {
                                                            variant: "success",
                                                            size: "sm",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.previewImageSelected(
                                                                media.src
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(" Preview ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            size: "lg",
          },
          model: {
            value: _vm.showImageModal,
            callback: function ($$v) {
              _vm.showImageModal = $$v
            },
            expression: "showImageModal",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mb-2",
            },
            [
              _c("h5", { staticClass: "ml-2" }, [_vm._v("Image Preview")]),
              _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { variant: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.showImageModal = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
          _c("b-img", {
            staticClass: "full-image",
            attrs: { src: _vm.selectedImage },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }